

















































































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import CompaniesSwitcher from "@/components/CompaniesSwitcher.vue";
import errorsUtil from "../utils/errorMappings";
import _ from "lodash";

@Component({
  components: {
    CompaniesSwitcher,
  },
})
export default class BulkSchemaCreate extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private companyId!: string;
  @Prop() private accountId!: string;
  @Prop() private data!: any;

  private loading = false;
  private errorMessageTop = "";
  private newFieldName = "";
  private fileTypes = ["CSV", "TSV", "PSV", "Other"];
  private fileType = this.fileTypes[0];
  private fileSeparator = "";
  private hasHeaderTypes = ["true", "false"];
  private hasFileHeader = false;
  private addedFields: any[] = [];

  mounted() {
    if (!this.data) {
      this.fileType = this.fileTypes[0];
      this.fileSeparator = "";
      this.hasFileHeader = true;
      this.addedFields = [];
    } else {
      this.fileType = this.getFileType(this.data.schema.delimiter);
      this.fileSeparator = this.data.schema.delimiter;
      this.hasFileHeader = this.data.schema.hasHeader;
      this.addedFields = this.data.schema.fields;
    }
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  isSavePossible() {
    return this.getDelimiter() != "" && this.addedFields.length != 0;
  }

  onFileTypeSelected(e) {
    this.fileType = e.detail.item.value;
  }

  onHasHeaderSelected(e) {
    this.hasFileHeader = e.detail.item.value == "true";
  }

  getDelimiter() {
    if (this.fileType == "CSV") {
      return ",";
    } else if (this.fileType == "PSV") {
      return "|";
    } else if (this.fileType == "TSV") {
      return "/t";
    } else {
      return this.fileSeparator;
    }
  }

  getFileType(delimiter: string) {
    if (delimiter == ",") {
      return "CSV";
    } else if (delimiter == "|") {
      return "PSV";
    } else if (delimiter == "/t") {
      return "TSV";
    } else {
      return "Other";
    }
  }

  cancel() {
    (this.$parent as any).previousStep();
  }

  async saveChanges() {
    this.loading = true;
    this.$store.commit("startLoading");
    const schemaData = {
      schema: {
        delimiter: this.getDelimiter(),
        fields: this.addedFields,
        hasHeader: this.hasFileHeader,
      },
      schemaType: "delimited",
    };
    try {
      const saveSchemaResponse = await this.$api.put(
        `item-classification-api/v1/company/${this.companyId}/defaultSchema`,
        schemaData
      );
      (this.$parent as any).nextStep();
      this.loading = false;
      this.$store.commit("stopLoading");
    } catch (error) {
      this.displayError(error);
      this.loading = false;
      this.$store.commit("stopLoading");
    }
  }

  onNewFieldNameChange(e) {
    this.newFieldName = e.target.value;
  }
  onFileSeparatorChange(e) {
    this.fileSeparator = e.target.value;
  }

  addField() {
    this.addedFields = this.addedFields.concat([
      {
        name: this.newFieldName,
        required: false,
        type: "string",
      },
    ]);
    this.newFieldName = "";
  }

  isAddPossible() {
    return this.newFieldName.trim() != "";
  }

  deleteField(e, fieldName) {
    this.addedFields = this.addedFields.filter((f) => f.name != fieldName);
  }
}
